import { JSX } from 'react';
import { AdminMiniWorkspace } from '../admin-mini/components/AdminMiniWorkspace';
import { COMPLIANCE_SNIFFER } from '../admin-mini/admin-mini.descriptors';
import { CreateComplianceSnifferModal } from './components/CreateComplianceSnifferModal';

/**
 * The admin half of Compliance Sniffer, on the Mini tab of a Nok Mini's edit screen.
 *
 * **This screen did not exist before 2026-09-11.** `MiniManagementContainer` had no entry for
 * `compliance_sniffer`, so the tab rendered a warning triangle reading "Use of this mini is
 * currently unavailable!". The only admin surface was a react-admin CRUD form that was a copy of
 * Mystery Shopper's, down to feeding itself Mystery Shopper's status list.
 *
 * It is four lines because everything a sniff and a mystery shop do the same way lives in
 * `admin-mini/`. What is left here is the composer, which is the one part with a payload of its
 * own.
 */
export const ComplianceSnifferContainer: () => JSX.Element = (): JSX.Element => (
    <AdminMiniWorkspace tool={ COMPLIANCE_SNIFFER }
                        blurb="Runs you started from HQ. A customer's own sniffs are not listed here."
                        createControl={ (): JSX.Element => <CreateComplianceSnifferModal /> } />
);
